<template>
  <div class="yikt_contact_body common_body">
    <!-- Privacy note -->
    <div class="yikt_contact_text" data-aos="fade-right">
      <p>お客様の個人情報につきましては、他の目的に使用することはございません、弊社「個人情報保護規定」に基づいて責任をもって管理いたします。<br/>
      詳しくは弊社「<a href="/policy">プライバシーポリシー</a>」をご参照ください。</p>
      <p class="mt15">代表電話 <a :href="'tel:'+(HomeInfo.Tel||'')">{{HomeInfo.Tel}}</a></p>
      <p class="mt15">採用については<a href="/recruit">こちら</a></p>
    </div>

    <!-- Steps -->
    <div class="yikt_contact_step_body" data-aos="fade-right">
      <el-steps :active="step" simple v-if="ww>850">
        <el-step title="必要事項の入力" icon="el-icon-edit"></el-step>
        <el-step title="入力の内容確認" icon="el-icon-tickets"></el-step>
        <el-step title="診療仮申込完了" icon="el-icon-circle-check"></el-step>
      </el-steps>
      <el-steps :active="step" simple v-else>
        <el-step title="入力" icon="el-icon-edit"></el-step>
        <el-step title="確認" icon="el-icon-tickets"></el-step>
        <el-step title="完了" icon="el-icon-circle-check"></el-step>
      </el-steps>
    </div>

    <!-- ============ STEP 0: INPUT ============ -->
    <div class="yikt_contact_form_body" v-show="step===0">
      <el-form :model="ruleForm" :rules="rules" ref="contactForm"
               label-width="260px" :label-position="ww>850?'left':'top'">

        <!-- 相談者種別 -->
        <el-form-item label="相談者種別" prop="typeContact" data-aos="fade-right">
          <el-radio-group v-model="ruleForm.typeContact">
            <el-radio v-for="(item,index) in radioList" :key="index" :label="index">{{ item.called }}</el-radio>
          </el-radio-group>
        </el-form-item>

        <!-- 代理人 -->
        <el-form-item label="代理人の方のお名前とご関係" prop="DaiName">
          <el-input data-aos="fade-right" v-model="ruleForm.DaiName" placeholder="(例) 醫健泰 太郎 母親"></el-input>
        </el-form-item>

        <!-- 氏名 -->
        <el-form-item label="お名前" prop="name">
          <el-input data-aos="fade-right" v-model="ruleForm.name" placeholder="(例) 醫健泰 太郎"></el-input>
        </el-form-item>

        <!-- アルファベット -->
        <el-form-item label="アルファベット" prop="nameFurigana">
          <el-input data-aos="fade-right" v-model="ruleForm.nameFurigana" placeholder="(例) IKENTAI TAIROU"></el-input>
        </el-form-item>

        <!-- 生年月日 -->
        <el-form-item label="生年月日" prop="birthDate">
          <el-config-provider :locale="ja">
            <el-date-picker
              v-model="ruleForm.birthDate"
              class="yikt-birth-date-picker"
              type="date"
              placeholder="生年月日を選択または入力してください"
              format="YYYY-MM-DD"
              value-format="YYYY-MM-DD"
              :disabled-date="disableFutureDate"
              data-aos="fade-right" />
          </el-config-provider>
        </el-form-item>

        <!-- 性別 -->
        <el-form-item label="性別" prop="sex" data-aos="fade-right">
          <el-radio-group v-model="ruleForm.sex">
            <el-radio v-for="(item,index) in sexList" :key="index" :label="index">{{ item.called }}</el-radio>
          </el-radio-group>
        </el-form-item>

        <!-- 電話番号 -->
        <el-form-item label="電話番号" class="is-required">
          <div class="yikt_contact_form_3" data-aos="fade-right">
            <el-form-item prop="phone" class="phone_input_item">
              <el-input type="tel" v-model="ruleForm.phone" @input="checkNumber('phone')" :maxlength="4"
                        placeholder="例: 03"></el-input>
            </el-form-item>
            <span class="yikt_contact_form_-">-</span>
            <el-form-item prop="phone2" class="phone_input_item">
              <el-input type="tel" v-model="ruleForm.phone2" @input="checkNumber('phone2')" :maxlength="4"
                        placeholder="1234"></el-input>
            </el-form-item>
            <span class="yikt_contact_form_-">-</span>
            <el-form-item prop="phone3" class="phone_input_item">
              <el-input type="tel" v-model="ruleForm.phone3" @input="checkNumber('phone3')" :maxlength="4"
                        placeholder="5678"></el-input>
            </el-form-item>
          </div>
        </el-form-item>

        <!-- メール -->
        <el-form-item label="メールアドレス" prop="email">
          <el-input data-aos="fade-right" v-model="ruleForm.email" placeholder="(例) info@example.com"></el-input>
        </el-form-item>

        <!-- 住所 -->
        <el-form-item label="住所" prop="address">
          <el-input data-aos="fade-right" v-model="ruleForm.address" placeholder="(例) 東京都千代田区神田錦町2-2-1"></el-input>
        </el-form-item>

        <!-- 国籍 -->
        <el-form-item label="国籍" prop="nationality" data-aos="fade-right">
          <el-radio-group v-model="ruleForm.nationality">
            <el-radio v-for="(item,index) in nationalityList" :key="index" :label="index">{{ item.called }}</el-radio>
          </el-radio-group>
        </el-form-item>

        <!-- ★ 第一言語 – 第二言語と連動 -->
        <el-form-item label="第一言語" prop="lan1">
          <el-select v-model="ruleForm.lan1" data-aos="fade-right"
                     placeholder="第一言語を選択してください" @change="onLan1Change">
            <el-option v-for="(item,index) in lan1Options" :key="index"
                       :label="item.called" :value="item.called"></el-option>
          </el-select>
        </el-form-item>

        <!-- ★ 第二言語 – 第一言語と連動 -->
        <el-form-item label="第二言語" prop="lan2">
          <el-select v-model="ruleForm.lan2" data-aos="fade-right"
                     placeholder="第二言語を選択してください" @change="onLan2Change">
            <el-option v-for="(item,index) in lan2Options" :key="index"
                       :label="item.called" :value="item.called"></el-option>
          </el-select>
          <span v-if="lanConflict" class="yikt-lang-warn">
            ※ 第一言語と第二言語は異なる言語を選択してください
          </span>
        </el-form-item>

        <!-- 相談目的 -->
        <el-form-item label="相談目的" prop="consultation">
          <el-checkbox v-model="ruleForm.consultation"
                       v-for="(item,index) in consultationList" :key="index" :label="index">{{ item.called }}</el-checkbox>
          <br/>
          <small>※（来日されるのがベターですが、ご本人情報をもとに、診断内容や治療方法等に関して専門医に助言のみを行うことを目的とし、必ず来日の必要はございません）</small>
        </el-form-item>

        <!-- ご相談内容 -->
        <el-form-item label="ご相談内容" prop="content">
          <el-input data-aos="fade-right" type="textarea" v-model="ruleForm.content"
                    placeholder="今回のご相談内容を出来る限り詳しくご入力下さいませ。" :rows="6"></el-input>
        </el-form-item>

        <!-- 希望医療機関 -->
        <el-form-item label="希望医療機関" prop="kibokikan" data-aos="fade-right">
          <el-radio-group v-model="ruleForm.kibokikan">
            <el-radio v-for="(item,index) in kibokikanList" :key="index" :label="index">{{ item.called }}</el-radio>
          </el-radio-group>
        </el-form-item>

        <!-- 受診国 -->
        <el-form-item label="受診国" prop="kuni">
          <el-input data-aos="fade-right" v-model="ruleForm.kuni" placeholder="(例) 中国"></el-input>
        </el-form-item>

        <!-- 医療機関名 -->
        <el-form-item label="医療機関名" prop="iryokikan">
          <el-input data-aos="fade-right" v-model="ruleForm.iryokikan" placeholder="(例) 聖路加国際病院"></el-input>
        </el-form-item>

        <!-- 診療科 -->
        <el-form-item label="診療科" prop="iryoka">
          <el-input data-aos="fade-right" v-model="ruleForm.iryoka" placeholder="(例) 一般内科"></el-input>
        </el-form-item>

        <!-- 診断名 -->
        <el-form-item label="診断名" prop="shidanmin">
          <el-input data-aos="fade-right" v-model="ruleForm.shidanmin" placeholder="(例) 健診・精密検査"></el-input>
        </el-form-item>

        <!-- 手術 -->
        <el-form-item label="手術" prop="shojutsu" data-aos="fade-right">
          <el-radio-group v-model="ruleForm.shojutsu">
            <el-radio v-for="(item,index) in shojutsuList" :key="index" :label="index">{{ item.called }}</el-radio>
          </el-radio-group>
        </el-form-item>

        <!-- ★ 提出可能な最新医療紙資料 – チェック数分アップロード -->
        <el-form-item label="提出可能な最新医療紙資料" prop="data" class="data_list" data-aos="fade-right">
          <div class="yikt-check-grid">
            <label v-for="(item,index) in dataList" :key="index" class="yikt-check-item"
                   :class="{checked: ruleForm.data.includes(index)}"
                   @click="toggleCheck('data',index)">
              <span class="yikt-check-box">{{ ruleForm.data.includes(index) ? '✓' : '' }}</span>
              {{ item.called }}
            </label>
          </div>
          <!-- ★ FIX 5: 選択した数だけアップロードエリア表示 -->
          <div v-if="ruleForm.data.length > 0" class="yikt-upload-section">
            <p class="yikt-upload-hint">📋 選択した資料をアップロードしてください（PDF または画像ファイル）</p>
            <div v-for="(idx, slot) in ruleForm.data" :key="'data-'+idx"
                 class="yikt-upload-slot" :class="{'has-file': dataFiles[slot]}"
                 @dragover.prevent="e => e.currentTarget.classList.add('drag-over')"
                 @dragleave="e => e.currentTarget.classList.remove('drag-over')"
                 @drop.prevent="e => onDrop(e,'data',slot)">
              <label class="yikt-upload-label">
                <input type="file" accept=".pdf,.jpg,.jpeg,.png,.gif,.webp,.bmp,.heic,.heif,image/*" class="yikt-upload-input"
                       @change="e => onFileChange(e,'data',slot)"/>
                <div v-if="!dataFiles[slot]" class="yikt-upload-placeholder">
                  <span class="yikt-upload-icon">📎</span>
                  <span class="yikt-upload-name">{{ dataList[idx].called }}</span>
                  <span class="yikt-upload-sub">クリックまたはドラッグでアップロード<br><small>PDF / JPG / PNG（1ファイル）</small></span>
                </div>
                <div v-else class="yikt-upload-done">
                  <span class="yikt-upload-icon-ok">✅</span>
                  <span class="yikt-upload-filename">{{ dataFiles[slot].name }}</span>
                  <span class="yikt-upload-size">{{ formatSize(dataFiles[slot].size) }}</span>
                  <button type="button" class="yikt-upload-remove" @click.stop.prevent="removeFile('data',slot)">✕</button>
                </div>
              </label>
            </div>
          </div>
        </el-form-item>

        <!-- ★ 提出可能な最新医療画像 – チェック数分アップロード -->
        <el-form-item label="提出可能な最新医療画像" prop="image_data" class="data_list" data-aos="fade-right">
          <div class="yikt-check-grid">
            <label v-for="(item,index) in imgDataList" :key="index" class="yikt-check-item"
                   :class="{checked: ruleForm.image_data.includes(index)}"
                   @click="toggleCheck('image_data',index)">
              <span class="yikt-check-box">{{ ruleForm.image_data.includes(index) ? '✓' : '' }}</span>
              {{ item.called }}
            </label>
          </div>
          <!-- ★ FIX 6: 選択した数だけアップロードエリア表示 -->
          <div v-if="ruleForm.image_data.length > 0" class="yikt-upload-section">
            <p class="yikt-upload-hint">🖼️ 選択した画像をアップロードしてください（PDF または画像ファイル）</p>
            <div v-for="(idx, slot) in ruleForm.image_data" :key="'img-'+idx"
                 class="yikt-upload-slot" :class="{'has-file': imgFiles[slot]}"
                 @dragover.prevent="e => e.currentTarget.classList.add('drag-over')"
                 @dragleave="e => e.currentTarget.classList.remove('drag-over')"
                 @drop.prevent="e => onDrop(e,'img',slot)">
              <label class="yikt-upload-label">
                <input type="file" accept=".pdf,.jpg,.jpeg,.png,.gif,.webp,.bmp,.heic,.heif,image/*" class="yikt-upload-input"
                       @change="e => onFileChange(e,'img',slot)"/>
                <div v-if="!imgFiles[slot]" class="yikt-upload-placeholder">
                  <span class="yikt-upload-icon">🖼️</span>
                  <span class="yikt-upload-name">{{ imgDataList[idx].called }}</span>
                  <span class="yikt-upload-sub">クリックまたはドラッグでアップロード<br><small>PDF / JPG / PNG（1ファイル）</small></span>
                </div>
                <div v-else class="yikt-upload-done">
                  <img v-if="isImage(imgFiles[slot]) && imgPreviews[slot]"
                       :src="imgPreviews[slot]" class="yikt-upload-preview-img"/>
                  <span v-else class="yikt-upload-icon-ok">✅</span>
                  <span class="yikt-upload-filename">{{ imgFiles[slot].name }}</span>
                  <span class="yikt-upload-size">{{ formatSize(imgFiles[slot].size) }}</span>
                  <button type="button" class="yikt-upload-remove" @click.stop.prevent="removeFile('img',slot)">✕</button>
                </div>
              </label>
            </div>
          </div>
        </el-form-item>

        <!-- 現在の状況 -->
        <el-form-item label="現在の状況" prop="status" class="data_list" data-aos="fade-right">
          <el-radio-group v-model="ruleForm.status">
            <el-radio v-for="(item,index) in statusList" :key="index" :label="index">{{ item.called }}</el-radio>
          </el-radio-group>
        </el-form-item>

        <!-- 来日歴 -->
        <el-form-item label="来日歴" prop="his_jp" class="data_list" data-aos="fade-right">
          <el-radio-group v-model="ruleForm.his_jp">
            <el-radio v-for="(item,index) in shojutsuList" :key="index" :label="index">{{ item.called }}</el-radio>
          </el-radio-group>
        </el-form-item>

        <!-- 来日ビザ -->
        <el-form-item label="来日ビザ" prop="visa_jp" class="data_list" data-aos="fade-right">
          <el-radio-group v-model="ruleForm.visa_jp">
            <el-radio v-for="(item,index) in visa_jpList" :key="index" :label="index">{{ item.called }}</el-radio>
          </el-radio-group>
        </el-form-item>

        <!-- ビザ種類 -->
        <el-form-item label="ビザ種類" class="data_list" prop="visatype">
          <el-select v-model="ruleForm.visatype" data-aos="fade-right" placeholder="ビザ種類を選択してください">
            <el-option v-for="(value,key,index) in visaList" :key="index"
                       :label="value.called" :value="value.called"></el-option>
          </el-select>
        </el-form-item>

        <!-- パスポートナンバー -->
        <el-form-item label="パスポートナンバー" class="data_list" prop="pusport">
          <el-input data-aos="fade-right" v-model="ruleForm.pusport" placeholder="(例) YK1234567"></el-input>
        </el-form-item>

        <!-- 医療ビザの申請 -->
        <el-form-item label="医療ビザの申請" class="data_list" prop="approve">
          <el-radio-group v-model="ruleForm.approve">
            <el-radio v-for="(item,index) in approveList" :key="index" :label="index">{{ item.called }}</el-radio>
          </el-radio-group>
        </el-form-item>

        <!-- 日本滞在予定期間 -->
        <el-form-item label="日本滞在予定期間" prop="yoteDate" class="data_list">
          <el-config-provider :locale="ja">
            <el-date-picker v-model="ruleForm.yoteDateFrom" type="date"
                placeholder="開始日を選んでください" format="YYYY-MM-DD" value-format="YYYY-MM-DD"
                @change="yoteDateFromInput" :locale="ja"/>
            <span style="margin:0 8px">〜</span>
            <el-date-picker v-model="ruleForm.yoteDateTo" type="date"
                placeholder="終了日を選んでください" format="YYYY-MM-DD" value-format="YYYY-MM-DD"
                @change="yoteDateFromInput" name="yoteDateTo_in" :locale="ja"/>
          </el-config-provider>
          <div class="el-form-item__error" v-if="isInValidDateTo">開始日が終了日より遅い日付です。</div>
        </el-form-item>

        <!-- 診察第一希望日 -->
        <el-form-item label="診察第一希望日" prop="shisatsuDate1" class="data_list">
          <el-config-provider :locale="ja">
            <el-date-picker v-model="ruleForm.shisatsuDate1" type="datetime"
                placeholder="診察第一希望日を選んでください"
                format="YYYY-MM-DD HH:mm" value-format="YYYY-MM-DD HH:mm" :locale="ja"/>
          </el-config-provider>
        </el-form-item>

        <!-- 診察第二希望日 -->
        <el-form-item label="診察第二希望日" prop="shisatsuDate2" class="data_list">
          <el-config-provider :locale="ja">
            <el-date-picker v-model="ruleForm.shisatsuDate2" type="datetime"
                placeholder="診察第二希望日を選んでください"
                format="YYYY-MM-DD HH:mm" value-format="YYYY-MM-DD HH:mm" :locale="ja"/>
          </el-config-provider>
        </el-form-item>

        <!-- 個人情報同意 -->
        <el-form-item label-width="0px" class="tc" data-aos="fade-right">
          <div class="yikt_contact_form_agree_content_title">診療仮申込における個人情報の取り扱いについて</div>
          <div class="yikt_contact_form_agree_content">
            <h5>(１)　事業者の名称</h5><p>{{HomeInfo.CompanyName}}</p><br/>
            <h5>(２)　個人情報保護管理者の氏名又は職名、所属及び連絡先</h5>
            <p>個人情報保護管理者：代表取締役　{{HomeInfo.Representative}}<br/>メール：{{HomeInfo.Email}}<br/>ＴＥＬ：{{HomeInfo.Tel}}</p><br/>
            <h5>(３)　個人情報の利用目的</h5><p>診療仮申込、資料請求に対応するするため。</p><br/>
            <h5>(４)　個人情報の第三者提供について</h5><p>取得した個人情報は法令等による場合を除いて第三者に提供することはありません。</p><br/>
            <h5>(５)　個人情報の取扱いの委託について</h5><p>取得した個人情報の取扱いの全部又は、一部を委託することがあります。</p><br/>
            <h5>(６)　個人情報を与えなかった場合に生じる結果</h5><p>個人情報のご提供は任意です。ただし、診療仮申込に必要な個人情報をご提供いただけない場合は、診療仮申込内容に回答出来ない可能性があります。</p><br/>
            <h5>(７)　開示対象個人情報の開示等および問い合わせ窓口について</h5>
            <p>ご本人からの請求により、当社が保有する開示対象個人情報に関する開示、利用目的の通知、内容の訂正・追加または削除、利用停止、消去および第三者提供の停止、第三者提供記録の開示に応じます。</p><br/>
            <h5>(８)　本人が容易に認識できない方法による個人情報の取得</h5><p>クッキーやウェブビーコン等を用いるなどして、本人が容易に認識できない方法による個人情報の取得は行っておりません。</p><br/>
            <h5>(９)　個人情報の安全管理措置について</h5><p>取得した個人情報については、漏洩、減失またはき損の防止と是正、その他個人情報の安全管理のために必要かつ適切な措置を講じます。</p><br/>
            <h5>(１０)　個人情報保護方針</h5><p>当社ホームページの個人情報保護方針をご覧下さい。</p><br/>
            <h5>(１１)　当社の個人情報の取扱いに関する苦情、相談等の問合せ先</h5>
            <p>【個人情報診療仮申込窓口】<br/>窓口責任者：個人情報保護管理者<br/>住所：〒{{HomeInfo.PostCode}} {{HomeInfo.Address}} {{ HomeInfo.Building }}<br/>会社：{{HomeInfo.CompanyName}}<br/>ＴＥＬ：{{HomeInfo.Tel}}<br/>メール：{{HomeInfo.Email}}</p>
          </div>
        </el-form-item>

        <el-form-item label-width="0px" class="tc is-required" data-aos="fade-right">
          <el-checkbox v-model="ruleForm.agree">個人情報の取り扱いについて同意します</el-checkbox>
        </el-form-item>

        <!-- ★ FIX 4: 送信ボタン -->
        <el-form-item label-width="0px" class="tc" data-aos="fade-right">
          <div class="tc">
            <button type="button" @click="doSubmitForm()" class="octf-btn octf-btn-primary octf-btn-icon octf-btn-third home_img_right yikt-submit-btn">
              <span>&emsp;入力内容を確認する&emsp;<i class="bi bi-arrow-right"></i></span>
            </button>
          </div>
        </el-form-item>
      </el-form>
    </div><!-- /STEP 0 -->

    <!-- ============ STEP 1: CONFIRM ============ -->
    <div v-show="step===1" class="yikt_contact_form_check_body">
      <table class="yikt_contact_form_check_table">
        <tbody>
          <tr data-aos="fade-right"><td class="yikt_contact_form_check_title">相談者種別</td><td class="yikt_contact_form_check_content">{{ getLabel(ruleForm.typeContact,radioList) }}</td></tr>
          <tr data-aos="fade-right" v-if="ruleForm.DaiName"><td class="yikt_contact_form_check_title">代理人</td><td class="yikt_contact_form_check_content">{{ ruleForm.DaiName }}</td></tr>
          <tr data-aos="fade-right"><td class="yikt_contact_form_check_title">お名前</td><td class="yikt_contact_form_check_content">{{ ruleForm.name }}</td></tr>
          <tr data-aos="fade-right"><td class="yikt_contact_form_check_title">アルファベット</td><td class="yikt_contact_form_check_content">{{ ruleForm.nameFurigana }}</td></tr>
          <tr data-aos="fade-right"><td class="yikt_contact_form_check_title">生年月日</td><td class="yikt_contact_form_check_content">{{ ruleForm.birthDate }}</td></tr>
          <tr data-aos="fade-right"><td class="yikt_contact_form_check_title">性別</td><td class="yikt_contact_form_check_content">{{ getLabel(ruleForm.sex,sexList) }}</td></tr>
          <tr data-aos="fade-right"><td class="yikt_contact_form_check_title">電話番号</td><td class="yikt_contact_form_check_content">{{ ruleForm.phone }}-{{ ruleForm.phone2 }}-{{ ruleForm.phone3 }}</td></tr>
          <tr data-aos="fade-right"><td class="yikt_contact_form_check_title">メールアドレス</td><td class="yikt_contact_form_check_content">{{ ruleForm.email }}</td></tr>
          <tr data-aos="fade-right" v-if="ruleForm.address"><td class="yikt_contact_form_check_title">住所</td><td class="yikt_contact_form_check_content">{{ ruleForm.address }}</td></tr>
          <tr data-aos="fade-right" v-if="ruleForm.nationality!==''"><td class="yikt_contact_form_check_title">国籍</td><td class="yikt_contact_form_check_content">{{ getLabel(ruleForm.nationality,nationalityList) }}</td></tr>
          <tr data-aos="fade-right" v-if="ruleForm.lan1"><td class="yikt_contact_form_check_title">第一言語</td><td class="yikt_contact_form_check_content">{{ ruleForm.lan1 }}</td></tr>
          <tr data-aos="fade-right" v-if="ruleForm.lan2"><td class="yikt_contact_form_check_title">第二言語</td><td class="yikt_contact_form_check_content">{{ ruleForm.lan2 }}</td></tr>
          <tr data-aos="fade-right"><td class="yikt_contact_form_check_title">相談目的</td><td class="yikt_contact_form_check_content type_content">{{ getCheckBox(ruleForm.consultation,consultationList) }}</td></tr>
          <tr data-aos="fade-right" v-if="ruleForm.content"><td class="yikt_contact_form_check_title">ご相談内容</td><td class="yikt_contact_form_check_content">{{ ruleForm.content }}</td></tr>
          <tr data-aos="fade-right" v-if="ruleForm.kibokikan!==''"><td class="yikt_contact_form_check_title">希望医療機関</td><td class="yikt_contact_form_check_content">{{ getLabel(ruleForm.kibokikan,kibokikanList) }}</td></tr>
          <tr data-aos="fade-right" v-if="ruleForm.kuni"><td class="yikt_contact_form_check_title">受診国</td><td class="yikt_contact_form_check_content">{{ ruleForm.kuni }}</td></tr>
          <tr data-aos="fade-right" v-if="ruleForm.iryokikan"><td class="yikt_contact_form_check_title">医療機関名</td><td class="yikt_contact_form_check_content">{{ ruleForm.iryokikan }}</td></tr>
          <tr data-aos="fade-right" v-if="ruleForm.iryoka"><td class="yikt_contact_form_check_title">診療科</td><td class="yikt_contact_form_check_content">{{ ruleForm.iryoka }}</td></tr>
          <tr data-aos="fade-right" v-if="ruleForm.shidanmin"><td class="yikt_contact_form_check_title">診断名</td><td class="yikt_contact_form_check_content">{{ ruleForm.shidanmin }}</td></tr>
          <tr data-aos="fade-right" v-if="ruleForm.shojutsu!==''"><td class="yikt_contact_form_check_title">手術</td><td class="yikt_contact_form_check_content">{{ getLabel(ruleForm.shojutsu,shojutsuList) }}</td></tr>
          <tr data-aos="fade-right" v-if="ruleForm.data.length>0">
            <td class="yikt_contact_form_check_title">提出可能な最新医療紙資料</td>
            <td class="yikt_contact_form_check_content">
              {{ getCheckBox(ruleForm.data,dataList) }}
              <span v-if="dataFiles.some(f=>f)" class="yikt-confirm-files">
                （ファイル: {{ dataFiles.filter(f=>f).map(f=>f.name).join('、') }}）
              </span>
            </td>
          </tr>
          <tr data-aos="fade-right" v-if="ruleForm.image_data.length>0">
            <td class="yikt_contact_form_check_title">提出可能な最新医療画像</td>
            <td class="yikt_contact_form_check_content">
              {{ getCheckBox(ruleForm.image_data,imgDataList) }}
              <span v-if="imgFiles.some(f=>f)" class="yikt-confirm-files">
                （ファイル: {{ imgFiles.filter(f=>f).map(f=>f.name).join('、') }}）
              </span>
            </td>
          </tr>
          <tr data-aos="fade-right" v-if="ruleForm.status!==''"><td class="yikt_contact_form_check_title">現在の状況</td><td class="yikt_contact_form_check_content">{{ getLabel(ruleForm.status,statusList) }}</td></tr>
          <tr data-aos="fade-right" v-if="ruleForm.his_jp!==''"><td class="yikt_contact_form_check_title">来日歴</td><td class="yikt_contact_form_check_content">{{ getLabel(ruleForm.his_jp,shojutsuList) }}</td></tr>
          <tr data-aos="fade-right" v-if="ruleForm.visa_jp!==''"><td class="yikt_contact_form_check_title">来日ビザ</td><td class="yikt_contact_form_check_content">{{ getLabel(ruleForm.visa_jp,visa_jpList) }}</td></tr>
          <tr data-aos="fade-right" v-if="ruleForm.visatype"><td class="yikt_contact_form_check_title">ビザ種類</td><td class="yikt_contact_form_check_content">{{ ruleForm.visatype }}</td></tr>
          <tr data-aos="fade-right" v-if="ruleForm.pusport"><td class="yikt_contact_form_check_title">パスポートナンバー</td><td class="yikt_contact_form_check_content">{{ ruleForm.pusport }}</td></tr>
          <tr data-aos="fade-right" v-if="ruleForm.approve!==''"><td class="yikt_contact_form_check_title">医療ビザの申請</td><td class="yikt_contact_form_check_content">{{ getLabel(ruleForm.approve,approveList) }}</td></tr>
          <tr data-aos="fade-right" v-if="ruleForm.yoteDateFrom"><td class="yikt_contact_form_check_title">日本滞在予定期間</td><td class="yikt_contact_form_check_content">{{ ruleForm.yoteDateFrom }}〜{{ ruleForm.yoteDateTo }}</td></tr>
          <tr data-aos="fade-right" v-if="ruleForm.shisatsuDate1"><td class="yikt_contact_form_check_title">診察第一希望日</td><td class="yikt_contact_form_check_content">{{ ruleForm.shisatsuDate1 }}</td></tr>
          <tr data-aos="fade-right" v-if="ruleForm.shisatsuDate2"><td class="yikt_contact_form_check_title">診察第二希望日</td><td class="yikt_contact_form_check_content">{{ ruleForm.shisatsuDate2 }}</td></tr>
        </tbody>
      </table>
      <div class="tc" style="margin-top:28px">
        <a href="javascript:void(0)" @click="backform()" class="octf-btn octf-btn-primary octf-btn-icon" tabindex="-1">
          <span>前画面へ戻る<i class="bi bi-arrow-right"></i></span>
        </a>
        &emsp;&emsp;
        <button type="button" @click="sendMail()" :disabled="sending"
          :class="['octf-btn octf-btn-primary octf-btn-icon octf-btn-third home_img_right yikt-submit-btn', {disabled:sending}]">
          <span>&emsp;{{ sending ? '送信中...' : '診療仮申込' }}&emsp;<i class="bi bi-arrow-right"></i></span>
        </button>
      </div>
    </div><!-- /STEP 1 -->

    <!-- ============ STEP 2: COMPLETE ============ -->
    <div v-show="step===2" class="yikt_contact_form_send_ok_body tc">
      <i class="el-icon-success yikt_contact_form_send_ok_ico"></i>
      <br/>
      <p class="f18" data-aos="fade-right">
        診療仮申込ありがとうございました。<br/>
        診療仮申込は正常に完了しました。<br/><br/>
      </p>
      <div class="tc mt30" data-aos="fade-right">
        <a href="javascript:void(0)" @click="backtop()" class="octf-btn octf-btn-primary octf-btn-icon octf-btn-third home_img_right" tabindex="-1">
          <span>トップページへ戻る<i class="bi bi-arrow-right"></i></span>
        </a>
      </div>
    </div><!-- /STEP 2 -->

  </div>
</template>

<script>
const radioList      = [{called:'患者様本人'},{called:'患者様本人以外'}];
const sexList        = [{called:'男性'},{called:'女性'}];
const nationalityList= [{called:'中国'},{called:'日本'},{called:'米国'},{called:'韓国'},{called:'その他'}];
const consultationList=[{called:'検診'},{called:'検査・治療'},{called:'セカンドオピニオン'},{called:'美容治療'},{called:'歯科治療'}];
const kibokikanList  = [{called:'あり'},{called:'なし'}];
const shojutsuList   = [{called:'有'},{called:'無'}];
const statusList     = [{called:'治療中'},{called:'治療中ではない'}];
const visa_jpList    = [{called:'申請済'},{called:'申請中'}];
const approveList    = [{called:'申請する'},{called:'申請しない'},{called:'未定（必要性の証明必要）'}];
const imgDataList    = [{called:'CT'},{called:'ET-CT'},{called:'MRI'},{called:'MRA'},{called:'エコー'},{called:'X線'},{called:'その他'}];
const dataList       = [{called:'血液検査結果'},{called:'手術記録診断書'},{called:'組織検査結果'},{called:'採尿検査結果'},{called:'心電図検査結果'},{called:'その他'}];
const visaList       = [
  {called:'医療'},{called:'短期滞在'},{called:'介護'},{called:'留学'},{called:'研修'},
  {called:'家族滞在'},{called:'高度専門職'},{called:'経営・管理'},
  {called:'技術・人文知識・国際業務'},{called:'特定技能'},{called:'技能実習'},
  {called:'企業内転勤'},{called:'興行'},{called:'法律・会計業務'},{called:'報道'},
  {called:'外交'},{called:'公用'},{called:'教授'},{called:'芸術'},{called:'宗教'},
  {called:'研究'},{called:'特定活動'},{called:'永住者'},{called:'日本人の配偶者等'},
  {called:'永住者の配偶者等'},{called:'定住者'}
];
const options = [
  {called:'中国語'},{called:'英語'},{called:'日本語'},{called:'韓国語'},
  {called:'モンゴル語'},{called:'タガログ語'},{called:'ベトナム語'},
  {called:'ラオス語'},{called:'クメール語'},{called:'タイ語'},
  {called:'ビルマ語'},{called:'マレー語'},{called:'インドネシア語'},{called:'その他'}
];

import ja from 'element-plus/lib/locale/lang/ja';

export default {
  name: 'MailFrom',
  data() {
    const currentYear = new Date().getFullYear();
    const years = [];
    for (let y = currentYear; y >= 1920; y--) years.push(y);
    return {
      step: 0,
      ja,
      ww: window.innerWidth,
      isInValidDateTo: false,
      lanConflict: false,
      sending: false,
      // Lists
      radioList, sexList, nationalityList, consultationList,
      kibokikanList, shojutsuList, statusList, visa_jpList,
      approveList, imgDataList, dataList, visaList,
      // ★ FIX 8: birth selects
      birthYears: years,
      birthYear: '',
      birthMonth: '',
      birthDay: '',
      // ★ FIX 5&6: file arrays
      dataFiles: [],
      imgFiles: [],
      imgPreviews: [],
      // Form data
      ruleForm: {
        typeContact: 0, DaiName: '', name: '', nameFurigana: '', birthDate: '',
        sex: 0, phone: '', phone2: '', phone3: '', email: '', address: '',
        nationality: 0, lan1: '', lan2: '',
        consultation: [0], content: '',
        kibokikan: 1, kuni: '', iryokikan: '', iryoka: '', shidanmin: '',
        shojutsu: 1, data: [], image_data: [],
        status: 1, his_jp: 1, visa_jp: '', visatype: '', pusport: '', approve: '',
        yoteDateFrom: '', yoteDateTo: '', shisatsuDate1: '', shisatsuDate2: '',
        agree: false
      },
      rules: {
        name:        [{ required: true, message: 'お名前を入力してください', trigger: 'blur' }],
        birthDate:   [{ required: true, message: '生年月日を選択してください', trigger: 'change' }],
        nameFurigana:[{ required: true, pattern: /^[a-zA-Z\s]+$/u, message: 'アルファベットで入力してください', trigger: 'blur' }],
        phone:       [{ required: true, pattern: /^[0-9]{2,4}$/, message: '電話番号を入力してください', trigger: 'blur' }],
        phone2:      [{ required: true, pattern: /^[0-9]{2,4}$/, message: '電話番号を入力してください', trigger: 'blur' }],
        phone3:      [{ required: true, pattern: /^[0-9]{4}$/,   message: '電話番号を入力してください', trigger: 'blur' }],
        email:       [{ required: true, type: 'email', message: 'メールアドレスを正しく入力してください', trigger: 'blur' }],
        content:     [{ required: true, message: 'ご相談内容を入力してください', trigger: 'blur' }]
      }
    };
  },
  computed: {
    // ★ FIX 8: days in selected month
    birthDayOptions() {
      if (!this.birthMonth) return Array.from({length:31},(_,i)=>i+1);
      const y = this.birthYear || 2000;
      const days = new Date(y, this.birthMonth, 0).getDate();
      return Array.from({length:days},(_,i)=>i+1);
    },
    // ★ FIX 7: language mutual exclusion
    lan1Options() {
      if (!this.ruleForm.lan2) return options;
      return options.filter(o => o.called !== this.ruleForm.lan2);
    },
    lan2Options() {
      if (!this.ruleForm.lan1) return options;
      return options.filter(o => o.called !== this.ruleForm.lan1);
    }
  },
  methods: {
    disableFutureDate(time) {
      return time.getTime() > Date.now();
    },
    // 旧セレクト方式の値が残っている場合のみ使用
    onBirthChange() {
      const maxDay = this.birthDayOptions.length;
      if (this.birthDay > maxDay) this.birthDay = maxDay;
      if (this.birthYear && this.birthMonth && this.birthDay) {
        const m = String(this.birthMonth).padStart(2,'0');
        const d = String(this.birthDay).padStart(2,'0');
        this.ruleForm.birthDate = `${this.birthYear}-${m}-${d}`;
      } else {
        this.ruleForm.birthDate = '';
      }
    },
    // ★ FIX 7
    onLan1Change() {
      if (this.ruleForm.lan1 && this.ruleForm.lan1 === this.ruleForm.lan2) {
        this.ruleForm.lan2 = '';
        this.lanConflict = true;
        setTimeout(() => { this.lanConflict = false; }, 3000);
      }
    },
    onLan2Change() {
      if (this.ruleForm.lan2 && this.ruleForm.lan1 === this.ruleForm.lan2) {
        this.ruleForm.lan1 = '';
        this.lanConflict = true;
        setTimeout(() => { this.lanConflict = false; }, 3000);
      }
    },
    // Custom checkbox toggle (replaces el-checkbox for 5&6)
    toggleCheck(field, index) {
      const arr = [...this.ruleForm[field]];
      const pos = arr.indexOf(index);
      if (pos === -1) {
        arr.push(index);
      } else {
        arr.splice(pos, 1);
        if (field === 'data') {
          const files = [...this.dataFiles];
          files.splice(pos, 1);
          this.dataFiles = files;
        }
        if (field === 'image_data') {
          const files = [...this.imgFiles];
          const previews = [...this.imgPreviews];
          files.splice(pos, 1);
          previews.splice(pos, 1);
          this.imgFiles = files;
          this.imgPreviews = previews;
        }
      }
      this.ruleForm[field] = arr;
    },
    // ★ FIX 5&6: file handling
    validateFileType(file) {
      const ok = ['application/pdf','image/jpeg','image/png','image/gif','image/webp','image/bmp','image/heic','image/heif'];
      if (ok.includes(file.type) || (file.type && file.type.startsWith('image/'))) return true;
      return /\.(pdf|jpg|jpeg|png|gif|webp|bmp|heic|heif)$/i.test(file.name);
    },
    isImage(file) { return file && file.type && file.type.startsWith('image/'); },
    formatSize(b) {
      if (b < 1024) return b+'B';
      if (b < 1024*1024) return (b/1024).toFixed(1)+'KB';
      return (b/1048576).toFixed(1)+'MB';
    },
    setFile(type, slot, file) {
      if (type === 'data') {
        const a = [...this.dataFiles]; a[slot] = file; this.dataFiles = a;
      } else {
        const a = [...this.imgFiles]; a[slot] = file; this.imgFiles = a;
        if (this.isImage(file)) {
          const r = new FileReader();
          r.onload = ev => { const p=[...this.imgPreviews]; p[slot]=ev.target.result; this.imgPreviews=p; };
          r.readAsDataURL(file);
        }
      }
    },
    onFileChange(e, type, slot) {
      const file = e.target.files[0];
      if (!file) return;
      if (!this.validateFileType(file)) {
        this.$message({message:'PDFまたは画像ファイルのみアップロードできます。',type:'warning'});
        e.target.value=''; return;
      }
      this.setFile(type, slot, file);
    },
    onDrop(e, type, slot) {
      e.currentTarget.classList.remove('drag-over');
      const file = e.dataTransfer.files[0];
      if (!file) return;
      if (!this.validateFileType(file)) {
        this.$message({message:'PDFまたは画像ファイルのみアップロードできます。',type:'warning'}); return;
      }
      this.setFile(type, slot, file);
    },
    removeFile(type, slot) {
      if (type==='data') { const a=[...this.dataFiles]; a[slot]=null; this.dataFiles=a; }
      else { const a=[...this.imgFiles]; a[slot]=null; this.imgFiles=a;
             const p=[...this.imgPreviews]; p[slot]=null; this.imgPreviews=p; }
    },
    // Helpers
    getLabel(index, list) {
      if (index===''||index===null||index===undefined) return '';
      const i=Number(index);
      return (Number.isInteger(i)&&list&&list[i]) ? (list[i].called||'') : '';
    },
    getCheckBox(idxs, list) {
      if (!Array.isArray(idxs)) idxs=[];
      return idxs.map(i=>{ const n=Number(i); return list&&list[n]?list[n].called:''; }).filter(Boolean).join('、');
    },
    yoteDateFromInput() {
      this.isInValidDateTo = false;
      if (this.ruleForm.yoteDateFrom && this.ruleForm.yoteDateTo &&
          new Date(this.ruleForm.yoteDateFrom) > new Date(this.ruleForm.yoteDateTo)) {
        this.isInValidDateTo = true;
      }
    },
    checkNumber(name) { this.ruleForm[name] = String(this.ruleForm[name]).replace(/[^\d]/g,''); },
    backtop()  { window.location.href = '/'; },
    backform() { this.step = 0; window.scrollTo(0,0); },

    // ★ FIX 4: main submit button handler
    doSubmitForm() {
      const formRef = this.$refs.contactForm;
      if (!formRef) {
        console.error('contactForm ref not found');
        this.$message({message:'フォームのエラーです。ページを再読み込みしてください。',type:'error'});
        return;
      }
      formRef.validate(valid => {
        if (!valid) {
          this.$message({message:'必須項目を入力してください。',type:'warning'});
          this.$nextTick(() => {
            const el = document.querySelector('.el-form-item.is-error');
            if (el) el.scrollIntoView({behavior:'smooth', block:'center'});
          });
          return false;
        }
        if (this.isInValidDateTo) {
          this.$message({message:'日本滞在予定期間の日付が正しくありません。',type:'warning'});
          return false;
        }
        if (!this.ruleForm.agree) {
          this.$message({message:'「個人情報の取り扱いについて同意します」をチェックしてください。',type:'warning'});
          return false;
        }
        if (this.ruleForm.lan1 && this.ruleForm.lan2 && this.ruleForm.lan1 === this.ruleForm.lan2) {
          this.$message({message:'第一言語と第二言語は異なる言語を選択してください。',type:'warning'});
          return false;
        }
        this.step = 1;
        window.scrollTo(0, 0);
      });
    },

    // ★ FIX 4: actual mail send with FormData
    sendMail() {
      if (this.sending) return;
      this.sending = true;
      const fd = new FormData();
      fd.append('typeContact',   this.getLabel(this.ruleForm.typeContact, this.radioList));
      fd.append('DaiName',       this.ruleForm.DaiName);
      fd.append('name',          this.ruleForm.name);
      fd.append('nameFurigana',  this.ruleForm.nameFurigana);
      fd.append('birthDate',     this.ruleForm.birthDate);
      fd.append('sex',           this.getLabel(this.ruleForm.sex, this.sexList));
      fd.append('phone',         `${this.ruleForm.phone}-${this.ruleForm.phone2}-${this.ruleForm.phone3}`);
      fd.append('email',         this.ruleForm.email);
      fd.append('address',       this.ruleForm.address);
      fd.append('nationality',   this.getLabel(this.ruleForm.nationality, this.nationalityList));
      fd.append('lan1',          this.ruleForm.lan1);
      fd.append('lan2',          this.ruleForm.lan2);
      fd.append('consultation',  this.getCheckBox(this.ruleForm.consultation, this.consultationList));
      fd.append('content',       this.ruleForm.content.replace(/\r?\n/g,'<br>'));
      fd.append('kibokikan',     this.getLabel(this.ruleForm.kibokikan, this.kibokikanList));
      fd.append('kuni',          this.ruleForm.kuni);
      fd.append('iryokikan',     this.ruleForm.iryokikan);
      fd.append('iryoka',        this.ruleForm.iryoka);
      fd.append('shidanmin',     this.ruleForm.shidanmin);
      fd.append('shojutsu',      this.getLabel(this.ruleForm.shojutsu, this.shojutsuList));
      fd.append('data',          this.getCheckBox(this.ruleForm.data, this.dataList));
      fd.append('image_data',    this.getCheckBox(this.ruleForm.image_data, this.imgDataList));
      fd.append('status',        this.getLabel(this.ruleForm.status, this.statusList));
      fd.append('his_jp',        this.getLabel(this.ruleForm.his_jp, this.shojutsuList));
      fd.append('visa_jp',       this.getLabel(this.ruleForm.visa_jp, this.visa_jpList));
      fd.append('visatype',      this.ruleForm.visatype);
      fd.append('pusport',       this.ruleForm.pusport);
      fd.append('approve',       this.getLabel(this.ruleForm.approve, this.approveList));
      fd.append('yoteDate',      `${this.ruleForm.yoteDateFrom}〜${this.ruleForm.yoteDateTo}`);
      fd.append('shisatsuDate1', this.ruleForm.shisatsuDate1);
      fd.append('shisatsuDate2', this.ruleForm.shisatsuDate2);
      this.ruleForm.data.forEach((idx, slot) => { const f = this.dataFiles[slot]; if(f) fd.append('data_file_'+idx, f, f.name); });
      this.ruleForm.image_data.forEach((idx, slot) => { const f = this.imgFiles[slot]; if(f) fd.append('img_file_'+idx, f, f.name); });

      fetch('/api/mail.php?_='+Date.now(), { method:'POST', body:fd })
        .then(async r => {
          const text = await r.text();
          let res = null;
          try { res = JSON.parse(text); }
          catch (e) { throw new Error(text || ('HTTP ' + r.status)); }
          return res;
        })
        .then(res => {
          this.sending = false;
          if (res && res.code === 1) {
            // DB保存が成功した場合は、メール片方の失敗で申込者画面をエラー扱いにしない。
            if (res.msg) this.$message({message:res.msg, type:'success'});
            this.step = 2;
            window.scrollTo(0,0);
          } else {
            this.$message({message:(res&&res.msg)||'送信に失敗しました。入力内容またはメール設定をご確認ください。',type:'warning'});
          }
        })
        .catch(err => {
          this.sending = false;
          this.$message({message:'送信処理でエラーが発生しました。管理画面のメール設定、またはサーバーログをご確認ください。',type:'warning'});
          console.error(err);
        });
    }
  },
  mounted() {
    window.addEventListener('resize', () => { this.ww = window.innerWidth; });
  }
};
</script>

<style scoped>
/* Submit button */
.yikt-submit-btn{border:0;cursor:pointer;display:inline-flex;align-items:center;justify-content:center;}
.yikt-submit-btn.disabled,.yikt-submit-btn:disabled{opacity:.65;cursor:not-allowed;pointer-events:none;}

/* Birth date picker */
.yikt-birth-date-picker{width:260px;max-width:100%;}
:deep(.yikt-birth-date-picker .el-input__inner){height:42px;border-radius:8px;}

/* ★ FIX 7: Language warning */
.yikt-lang-warn{display:block;color:#e6a23c;font-size:12px;margin-top:6px;}

/* ★ FIX 5&6: Custom checkboxes */
.yikt-check-grid{display:flex;flex-wrap:wrap;gap:8px;margin-bottom:12px;}
.yikt-check-item{
  display:inline-flex;align-items:center;gap:6px;
  border:1.5px solid #dcdfe6;border-radius:8px;
  padding:6px 14px;cursor:pointer;font-size:13px;
  background:#fff;transition:all .15s;user-select:none;
}
.yikt-check-item:hover{border-color:#409eff;background:#f0f7ff;}
.yikt-check-item.checked{border-color:#409eff;background:#ecf5ff;color:#409eff;font-weight:700;}
.yikt-check-box{
  width:16px;height:16px;border-radius:4px;border:1.5px solid #c0c4cc;
  display:inline-flex;align-items:center;justify-content:center;
  font-size:11px;font-weight:900;transition:all .15s;flex-shrink:0;
}
.yikt-check-item.checked .yikt-check-box{background:#409eff;border-color:#409eff;color:#fff;}

/* Upload section */
.yikt-upload-section{margin-top:12px;display:flex;flex-direction:column;gap:10px;width:100%;}
.yikt-upload-hint{font-size:13px;color:#606266;margin:0 0 6px;font-weight:600;}
.yikt-upload-slot{
  border:2px dashed #d0dcea;border-radius:14px;background:#f8fbff;
  transition:border-color .2s,background .2s;overflow:hidden;
}
.yikt-upload-slot.has-file{border-style:solid;border-color:#67c23a;background:#f0fff6;}
.yikt-upload-slot.drag-over{border-color:#409eff;background:#ecf5ff;}
.yikt-upload-label{display:block;cursor:pointer;}
.yikt-upload-input{display:none;}
.yikt-upload-placeholder{
  display:flex;flex-direction:column;align-items:center;justify-content:center;
  padding:24px 16px;text-align:center;gap:6px;
}
.yikt-upload-icon{font-size:28px;line-height:1;}
.yikt-upload-name{font-weight:700;color:#1e3a5f;font-size:14px;}
.yikt-upload-sub{color:#909399;font-size:12px;line-height:1.7;}
.yikt-upload-done{display:flex;align-items:center;gap:12px;padding:14px 18px;flex-wrap:wrap;}
.yikt-upload-icon-ok{font-size:22px;}
.yikt-upload-preview-img{width:60px;height:60px;object-fit:cover;border-radius:8px;border:1px solid #e0ead8;}
.yikt-upload-filename{font-weight:700;color:#2d6a3f;flex:1;word-break:break-all;}
.yikt-upload-size{color:#909399;font-size:12px;white-space:nowrap;}
.yikt-upload-remove{
  background:none;border:none;color:#f56c6c;font-size:18px;cursor:pointer;
  padding:0 4px;line-height:1;margin-left:auto;
}
.yikt-upload-remove:hover{color:#e03c3c;}
.yikt-confirm-files{display:block;font-size:12px;color:#67c23a;margin-top:4px;}
</style>
